var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('v-alert',{attrs:{"dense":"","text":"","type":_vm.message.type}},[_vm._v(" "+_vm._s(_vm.message.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }